export default {
  title: 'Help & Support',

  // Common
  common: {
    of: 'of',
    createdAt: 'Created on',
    updatedAt: 'Updated on',
    by: 'by',
    cancel: 'Cancel',
  },

  // Status labels
  status: {
    open: 'Open',
    inProgress: 'In Progress',
    waiting: 'Waiting for response',
    resolved: 'Resolved',
    closed: 'Closed'
  },

  // Priority labels
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent'
  },

  // Filters
  filters: {
    all: 'All',
    status: 'Status',
    priority: 'Priority',
    search: 'Search tickets...'
  },

  // Quick actions
  quickActions: {
    title: 'Quick Actions',
    clearFilters: 'Clear Filters',
    export: 'Export Tickets'
  },

  // Stats
  stats: {
    open: 'Open',
    inProgress: 'In Progress',
    resolved: 'Resolved'
  },

  // Empty states
  empty: {
    noTickets: 'No tickets yet',
    createFirst: 'Create your first ticket to get help',
    noResults: 'No tickets found',
    tryDifferentFilters: 'Try adjusting your filters'
  },

  // Loading
  loading: {
    tickets: 'Loading tickets...',
    ticketDetails: 'Loading ticket details...',
    noTickets: 'No tickets found',
    description: 'You currently have no open tickets. Please create a new ticket to get help.',
  },

  // Time
  time: {
    justNow: 'just now',
    minutesAgo: '{count}m ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago'
  },

  // Validation
  validation: {
    required: 'This field is required'
  },

  // Toolbar
  toolbar: {
    title: 'Help & Support',
  },

  // Buttons
  btn: {
    newTicket: 'New Ticket',
    createTicket: 'Create Ticket',
  },

  // Tickets
  tickets: {
    title: 'Support Tickets',
    subtitle: 'Track and manage your support requests',
    myTickets: 'My Tickets',
    description: 'Find here the list of your support requests or reports.',
    showing: 'Showing {count} of {total} tickets',

    list: {
      title: 'Tickets List',
      noTickets: 'No tickets found',
      createTicket: 'Create a new ticket',
      noClosedTickets: 'No closed tickets',
      descriptionNoClosedTickets: 'You currently have no closed tickets.',
      noOpenTickets: 'No open tickets',
      descriptionNoOpenTickets: 'You currently have no open tickets.',
      filters: {
        status: 'Status',
        open: 'Open',
        closed: 'Closed',
        all: 'All',
      }
    },

    create: {
      title: 'Create a new ticket',
      subtitle: 'Describe your issue or request and our team will help you',
      priority: 'Priority',
      subject: 'Subject',
      subjectPlaceholder: 'Brief summary of the issue',
      description: 'Description',
      descriptionPlaceholder: 'Provide a detailed description of your issue or request...',
      createTicket: 'Create Ticket',
      category: 'Category',
      attachments: 'Attachments',
      attachmentsPlaceholder: 'Click to select files or drag and drop',
      submitSuccess: 'Ticket created successfully',
      submitError: 'Failed to create ticket',
      categories: {
        technical: 'Technical Issue',
        billing: 'Billing Question',
        feature: 'Feature Request',
        general: 'General Inquiry'
      },
      tips: {
        title: 'Tips for faster resolution',
        tip1: 'Be specific about the issue',
        tip2: 'Include error messages if any',
        tip3: 'Attach relevant screenshots',
        tip4: 'Mention steps to reproduce'
      },
      responseTime: {
        title: 'Expected response time',
        low: '48-72 hours',
        medium: '24-48 hours',
        high: '6-12 hours',
        urgent: '1-2 hours'
      }
    },

    detail: {
      title: 'Ticket Details',
      status: 'Status',
      priority: 'Priority',
      description: 'Description',
      messages: 'Conversation',
      newMessages: 'New messages',
      addMessage: 'Add a message',
      addReply: 'Add Reply',
      closeTicket: 'Close Ticket',
      reopenTicket: 'Reopen Ticket',
      send: 'Send',
      noMessages: 'No messages yet',
      typeMessage: 'Type your message...',
      messageSent: 'Message sent successfully',
      messageSendError: 'Failed to send message',
      ticketClosed: 'Ticket closed successfully',
      ticketReopened: 'Ticket reopened successfully',
      ticketClosedMessage: 'This ticket is closed. Reopen it to continue the conversation.',
      assignedTo: 'Assigned to',
      category: 'Category',
      created: 'Created',
      lastUpdate: 'Last update',
      resolution: 'Resolution',
      details: 'Details',
      requester: 'Requester',
      attachments: 'Attachments',
      supportTeam: 'Support Team',
      export: 'Export',
      print: 'Print',
      closeConfirmation: 'Are you sure you want to close this ticket?',
      closeReason: 'Resolution notes (optional)',
      confirmClose: 'Close Ticket',
      closeError: 'Failed to close ticket',
      reopenError: 'Failed to reopen ticket',
      loadError: 'Failed to load ticket details'
    }
  }
}
